import * as v from "valibot";
import { rpcContract } from "../rpc";

export const createCoPromotionRpcContract = rpcContract({
  name: "create-co-promotion",
  paramsSchema: v.object({
    entityType: v.picklist(["community", "live_event"]),
    entityId: v.string(),
    promoterIdentifier: v.pipe(v.string(), v.minLength(1)),
    identifierType: v.picklist(["handle", "email"]),
  }),
  resultSchema: v.object({
    coPromotionId: v.string(),
  }),
});

export type CreateCoPromotionParams = v.InferOutput<(typeof createCoPromotionRpcContract)["paramsSchema"]>;
export type CreateCoPromotionResult = v.InferOutput<(typeof createCoPromotionRpcContract)["resultSchema"]>;

export const revokeCoPromotionRpcContract = rpcContract({
  name: "revoke-co-promotion",
  paramsSchema: v.object({
    coPromotionId: v.string(),
  }),
  resultSchema: v.object({
    revoked: v.boolean(),
  }),
});

export type RevokeCoPromotionParams = v.InferOutput<(typeof revokeCoPromotionRpcContract)["paramsSchema"]>;
export type RevokeCoPromotionResult = v.InferOutput<(typeof revokeCoPromotionRpcContract)["resultSchema"]>;

export const getCoPromotersForEntityRpcContract = rpcContract({
  name: "get-co-promoters-for-entity",
  paramsSchema: v.object({
    entityType: v.picklist(["community", "live_event"]),
    entityId: v.string(),
  }),
  resultSchema: v.object({
    coPromoters: v.array(
      v.object({
        coPromotionId: v.string(),
        promoterId: v.string(),
        promoterHandle: v.nullable(v.string()),
        promoterDisplayName: v.string(),
        promoterAvatarUrl: v.nullable(v.string()),
        status: v.string(),
        createdAt: v.string(),
      }),
    ),
  }),
});

export type GetCoPromotersForEntityParams = v.InferOutput<(typeof getCoPromotersForEntityRpcContract)["paramsSchema"]>;
export type GetCoPromotersForEntityResult = v.InferOutput<(typeof getCoPromotersForEntityRpcContract)["resultSchema"]>;

export const getMyCoPromotionsRpcContract = rpcContract({
  name: "get-my-co-promotions",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    communities: v.array(
      v.object({
        coPromotionId: v.string(),
        communityId: v.string(),
        title: v.string(),
        thumbnailUrl: v.nullable(v.string()),
        status: v.string(),
        brandHandle: v.nullable(v.string()),
        brandDisplayName: v.string(),
        memberCount: v.number(),
      }),
    ),
    liveEvents: v.array(
      v.object({
        coPromotionId: v.string(),
        liveEventId: v.string(),
        title: v.string(),
        thumbnailUrl: v.nullable(v.string()),
        status: v.string(),
        brandHandle: v.nullable(v.string()),
        brandDisplayName: v.string(),
        scheduledStartTime: v.nullable(v.string()),
      }),
    ),
  }),
});

export type GetMyCoPromotionsParams = v.InferOutput<(typeof getMyCoPromotionsRpcContract)["paramsSchema"]>;
export type GetMyCoPromotionsResult = v.InferOutput<(typeof getMyCoPromotionsRpcContract)["resultSchema"]>;

export const searchCreatorForCoPromotionRpcContract = rpcContract({
  name: "search-creator-for-co-promotion",
  paramsSchema: v.object({
    query: v.optional(v.pipe(v.string(), v.minLength(1))),
  }),
  resultSchema: v.object({
    creators: v.array(
      v.object({
        userId: v.string(),
        handle: v.nullable(v.string()),
        displayName: v.string(),
        avatarUrl: v.nullable(v.string()),
        hasCoPromotionsFlag: v.boolean(),
      }),
    ),
  }),
});

export type SearchCreatorForCoPromotionParams = v.InferOutput<
  (typeof searchCreatorForCoPromotionRpcContract)["paramsSchema"]
>;
export type SearchCreatorForCoPromotionResult = v.InferOutput<
  (typeof searchCreatorForCoPromotionRpcContract)["resultSchema"]
>;
